import { Block } from '@/components/Block';
import { Popover } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import Link from 'next/link';
import classNames from 'classnames';
import { useScreenType } from '@/hooks/media';
import { Page } from '@/config/track-config';
import { BybitWalletChromeExtensionLink, appPath } from '@web3/base-utils';

const iconApp = `${appPath}/svg/home/icon-join-app.svg`;
const iconExtension = `${appPath}/svg/home/icon-join-extension.png`;
const iconTelegram = `${appPath}/svg/home/icon-join-telegram.svg`;
const iconTwitter = `${appPath}/svg/home/icon-join-twitter.svg`;
const downLoadImg = `${appPath}/svg/home/download-app.png`;

export function SectionJoin() {
  const fm = useFm();
  const { isMobile } = useScreenType();

  const joinData2 = [
    {
      label: 'Telegram',
      icon: iconTelegram,
      url: 'https://t.me/BybitEnglish',
    },
    {
      label: 'Twitter',
      icon: iconTwitter,
      url: 'https://twitter.com/Bybit_Web3',
    },
  ];
  return (
    <Block
      className="join-wrap mt-4 !md:mt-16"
      title={isMobile ? '' : fm('joinBybitWeb3')}
    >
      <div
        className={classNames([
          'flex justify-between',
          isMobile ? 'flex-col gap-4' : 'flex-row gap-8',
        ])}
      >
        {!isMobile && (
          <div className="bg-area rounded px-8 py-6 md:w-1/2 flex flex-col">
            <h2 className="text-2xl font-semibold">
              {fm('linkWalletJoinAirdrops')}
            </h2>
            <div className="flex mt-6 gap-6 flex-1">
              <Popover
                content={
                  <div>
                    <img className="w-40 h-40" src={downLoadImg} alt="" />
                    <p className="mt-2 text-sm">{fm('scan_to_download')}</p>
                  </div>
                }
                trigger="hover"
              >
                <div className="join-item cursor-pointer gap-2 text-lg">
                  <img className="w-8 h-8" src={iconApp} alt="Bybit App" />
                  <span>{fm('Bybit App')}</span>
                </div>
              </Popover>
              <Link
                href={BybitWalletChromeExtensionLink}
                target="_blank"
                data-spm-even="Web3UserClick"
                data-spm-data={JSON.stringify({
                  page_name: Page.AirdropArcadeHome,
                  button_name: 'Chrome Extension',
                })}
              >
                <div className="join-item flex gap-2 cursor-pointer text-lg h-12">
                  <img className="w-[34p5] h-8" src={iconExtension} alt="" />
                  <span>{fm('Chrome Extension')}</span>
                </div>
              </Link>
            </div>
          </div>
        )}
        <div
          className={classNames([
            'bg-area rounded flex flex-col',
            isMobile ? 'p-4 w-full' : 'px-8 py-6 w-1/2',
          ])}
        >
          <h2 className="text-xl md:text-2xl  font-semibold">
            {fm('joinOurCommunity')}
          </h2>
          <div className="flex mt-4 !md:mt-6 gap-6 flex-1">
            {joinData2.map((item, index) => (
              <Link
                href={item.url}
                target="_blank"
                key={index}
                data-spm-even="Web3UserClick"
                data-spm-data={JSON.stringify({
                  page_name: Page.AirdropArcadeHome,
                  button_name: item.label,
                })}
              >
                <div
                  key={item.label}
                  className="join-item flex gap-2 cursor-pointer !md:text-lg !md:h-12"
                >
                  <img
                    className="w-6 h-6 !md:w-8 !md:h-8"
                    src={item.icon}
                    alt=""
                  />
                  <span>{item.label}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </Block>
  );
}
